import * as React from 'react'
import cx from 'classnames'
import styles from './Select.m.sass'
import { ControlStatus } from '../ControlStatus'
import Icon from 'components/Icon'

export interface SelectInputProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  status?: ControlStatus
  value?: string
  items: any
  placeholder?: string | null
  children?: React.ReactNode
}

type SelectItem<V> = [V] | [V, string]

export function SelectInput<V>({
  className,
  value,
  onChange,
  status = 'default',
  items,
  children,
  placeholder,
  ...rest
}: SelectInputProps) {
  const icon = (
    <div className={styles.selectArrow}>
      <Icon size={24} rotate={90} name={'arrow'} />
    </div>
  )

  if (!items) {
    return (
      <div className={cx(styles.customSelect)}>
        <select
          className={cx(styles.select, className, styles[status])}
          value={value}
          onChange={onChange && ((e) => onChange(e))}
          {...rest}
        >
          {children}
        </select>
        {icon}
      </div>
    )
  }

  const selectValue = !value
    ? -1
    : items.findIndex(([key]: string) => key === value)
  return (
    <div className={cx(styles.customSelect)}>
      <select
        className={cx(styles.select, className)}
        onChange={onChange && ((e) => onChange(e))}
        value={selectValue === -1 ? '' : selectValue}
        {...rest}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {items.map((item: SelectItem<V>, index: number) => (
          <option key={index} value={index}>
            <>{item[1] || item[0]}</>
          </option>
        ))}
      </select>
      {icon}
    </div>
  )
}
